module.exports = __webpack_public_path__ + "fbf134bf54cbae48542eab1ed3800075.png";